export default "__VITE_ASSET__BQj9ETEw__"